module.exports = {
    apiKey: "AIzaSyB_UmXykHbQnR0zMUoyQC-N08CLCu4RVXk",
    authDomain: "balus-dev.firebaseapp.com",
    databaseURL: "https://balus-dev.firebaseio.com",
    projectId: "balus-dev",
    storageBucket: "balus-dev.appspot.com",
    messagingSenderId: "396235402511"
};



// WEBPACK FOOTER //
// ../etc/config/firebase/development.js